<template>
  <div id="app" class="app-main" >
    <router-view/>
  </div>
</template>

<script>
import dict from '@/mixins/dict'
export default {
  name: 'app',
  mixins: [ dict ],
  created () {}
}
</script>

<style>
html,body{
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  overflow: scroll;
}

.app-main{
  width: 100%;
  height: 100%;
}
</style>
